<template>
  <div class="dea-multiselect" v-on="$listeners">
    <p class="dea-heading--regular__ms">{{ label }}</p>
    <RadioButton
      v-for="(item, index) in values"
      :id="`${group}${item.value}`"
      :key="index"
      :name="group"
      :required="required"
      :value="item.value"
      >{{ item.label }}</RadioButton
    >
    <div
      :class="{
        'dea-input__icon--error dea-ico-error': currentState() === 'error',
        'dea-input__icon--success dea-ico-success': currentState() === 'success',
      }"
      class="dea-input__icon"
    ></div>
    <p
      v-if="message && currentState()"
      :class="{ 'dea-input__error-message': currentState() === 'error' }"
      class="dea-input__support-message"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
import RadioButton from "@/components/elements/RadioButton";

export default {
  name: "RadioMultiSelect",
  components: {
    RadioButton,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    values: {
      type: Array,
      default: () => [],
    },
    group: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Boolean, Number],
      default: "",
    },

    /**
     * Initial error state
     */
    state: {
      type: String,
      default: "",
    },

    /**
     * Initial error message
     */
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    currentState() {
      if (this.state) {
        return this.state;
      }
      return !this.value && this.validate ? "error" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/system.utils";

.dea-multiselect {
  position: relative;

  .dea-checkbox:not(:first-of-type) {
    margin-left: $space-base;
  }
}

.dea-checkbox {
  display: inline-block;
  margin-left: $space-x-small;
}

.dea-heading--regular__ms {
  margin-bottom: $space-x-small;
  margin-top: $space-small;
}

.dea-input__icon {
  top: $space-x-small + 22px;
}

.dea-input__error-message {
  margin-top: -$space-x-small;
  padding-bottom: $space-small;
}
</style>
